import { Card, CardContent, CardDescription, CardHeader, CardTitle, Link } from "@beweegbaas/ui";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { LayoutAuth } from "#/layouts/layout.auth";

// Outside `_authenticated` on purpose: its guard redirects here and must not loop.
export const Route = createFileRoute("/$locale/{-$schoolyear}/geen-school")({
  beforeLoad: ({ context, params }) => {
    if (!context.user || context.isAdmin || context.scholen.length > 0) {
      throw redirect({
        to: "/$locale/{-$schoolyear}/login",
        params: { locale: params.locale, schoolyear: params.schoolyear },
      });
    }
  },
  component: NoSchoolPage,
});

function NoSchoolPage() {
  const params = Route.useParams();
  return (
    <LayoutAuth>
      <title>{m["no_school.title"]()}</title>
      <Card className="w-full">
        <CardHeader>
          <CardTitle>{m["no_school.title"]()}</CardTitle>
          <CardDescription>
            {m["no_school.description_before_link"]()}
            <Link
              variant="secondary"
              underline={true}
              href="https://beweegbaas.nl/contact"
              target="_blank"
            >
              {m["no_school.contact_link"]()}
            </Link>
            {m["no_school.description_after_link"]()}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex justify-end text-sm">
            <Link to="/$locale/{-$schoolyear}/logout" params={params}>
              {m["common.actions.logout"]()}
            </Link>
          </div>
        </CardContent>
      </Card>
    </LayoutAuth>
  );
}
